import { render, staticRenderFns } from "./DeleteConfirmationDialog.vue?vue&type=template&id=2ccf4a1f&"
import script from "./DeleteConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteConfirmationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports